import React from "react";

export const About = () => {
  return (
    <div id="about" className="about-section">
      <div className="container">
        <div className="section-title">
          <h2>About Peak Risk Management</h2>
          <p>Empowering businesses with comprehensive risk management solutions</p>
        </div>
        
        <div className="about-content">
          <div className="about-left">
            <div className="about-text">
              <h3>Our Mission</h3>
              <p>
                To see risk clearly, to empower every employee and business to feel safe, supported, and informed. To illuminate the unseen threats and quiet vulnerabilities. A platform where a world of safety, compliance, and abundance is not a privilege, but a promise.
              </p>
              
              <h3>Our Vision</h3>
              <p>
                To be the trusted global choice for risk management - empowering businesses and individuals with safety, clarity, and care. To be a place where careers thrive, our people are valued, and purpose and prosperity are achieved in order to give you, our customer, world class support.
              </p>
            </div>
          </div>
          
          <div className="about-right">
            <div className="about-values">
              <h3>Our Values</h3>
              <ul>
                <li>
                  <i className="fa fa-heart"></i>
                  Compassion and Charity
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  Integrity
                </li>
                <li>
                  <i className="fa fa-cogs"></i>
                  Hard Work and Dependability
                </li>
                <li>
                  <i className="fa fa-eye"></i>
                  Clarity
                </li>
                <li>
                  <i className="fa fa-rocket"></i>
                  Empowerment
                </li>
                <li>
                  <i className="fa fa-lightbulb-o"></i>
                  Innovation
                </li>
              </ul>
            </div>
            
            <div className="about-quote">
              <h4>
                Our business exists, so you and your business can thrive!
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
